import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Pre-enrolled' },
    { value: 2, label: 'Current' },
    { value: 3, label: 'Former' },
    { value: 4, label: 'Pending' },
    { value: 5, label: 'Archived' },
  ],
});
